<template>
  <div>
    <Label class="mt-2">IBS</Label>
    <b-row>
      <b-col lg="3">
        <InputQuantity
          id="pCredPresIBS"
          label="Alíquota"
          inputClass="form-control input"
          labelBold
          v-model="
            productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.gCredPresOper.gIBSCredPres.pCredPres
          "
          :precision="4"
          :returnFormattedValue="false"
          disabled
          :max="8"
        />
      </b-col>
      <b-col lg="3">
        <InputMoney
          label="Valor"
          inputClass="form-control input"
          labelBold
          :precision="2"
          :returnFormattedValue="false"
          v-model="
            productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.gCredPresOper.gIBSCredPres.vCredPres
          "
        />
      </b-col>
      <b-col lg="3">
        <InputMoney
          label="Valor cond. sus."
          inputClass="form-control input"
          labelBold
          :precision="2"
          :returnFormattedValue="false"
          v-model="
            productOfPurchaseOnFiscalEdit.fiscal.IBSTaxRegime.gCredPresOper.gIBSCredPres
              .vCredPresCondSus
          "
          disabled
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { InputMoney, InputQuantity, Label } from '@/components/Form';

export default {
  name: 'CredPresOperIBS',
  components: {
    Label,
    InputMoney,
    InputQuantity,
  },
  computed: {
    ...mapState('purchase', ['productOfPurchaseOnFiscalEdit']),
  },
};
</script>
